// Section 9 and 13: Watch post. 6 build points, 6 wood; +1 safety point each; guards 1.5x;
// earlier warning of raids (the events stream checks `hasBuilding(state, 'watch-post')`).
// Constants: config.buildings['watch-post'].
import type { Config } from '../../config';
import { mod } from '../../core/modifiers';
import {
  buildingEffectHook,
  combineModifiers,
  effective,
  noDeltas,
} from '../../core/content-helpers';
import { defineBuilding } from '../../core/registry';

export function watchPost(config: Config) {
  const c = config.buildings['watch-post'];

  return defineBuilding({
    id: 'watch-post',
    label: 'Watch post',
    section: 'S9',
    buildPoints: c.buildPoints,
    materials: { wood: c.wood },
    material: 'wood',
    beds: 0,
    plots: 0,
    capacity: {},
    limit: { kind: 'none' },
    modifierTargets: ['service', 'output', 'buildingEffect'],
    modifierKeys: { output: ['guard'] },
    modifiers: combineModifiers(buildingEffectHook('watch-post'), (ctx, target) => {
      const e = effective(ctx, 'watch-post');
      if (e <= 0) return [];
      if (target.kind === 'service' && target.service === 'safetyPoints') {
        return [mod.add('building:watch-post', c.safetyPoints * e, 'watch post')];
      }
      if (target.kind === 'output' && target.jobId === 'guard') {
        return [
          mod.mul('building:watch-post', 1 + (c.guardFactor - 1) * Math.min(1, e), 'watch post'),
        ];
      }
      return [];
    }),
    onComplete: noDeltas,
    onDamaged: noDeltas,
  });
}
